<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        value: string | null;
        link?: string | null;
    }>(),
    { value: null },
);
</script>

<template>
    <div class="field-renderer-text">
        <a
            :href="link ?? value ?? '#'"
            target="_new"
            >{{ value }}</a
        >
    </div>
</template>
